export default "__VITE_ASSET__s8fBcdpp__"